// extracted by mini-css-extract-plugin
export default {"size25SVG":"_1LGAIxI3mJEvAgOhUghpoI","viewIcon":"_3WHerk786pVRTuNgj8wtuY","viewIconDisabled":"_2Wj21Qtjpv4CMK4vdBWN3V","customPopover":"_3eDEIPdg89_AdO1i-wEaBz"};